import { render, staticRenderFns } from "./SubcontractorBalances.vue?vue&type=template&id=bc4d4496&scoped=true"
import script from "./SubcontractorBalances.vue?vue&type=script&lang=js"
export * from "./SubcontractorBalances.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorBalances.vue?vue&type=style&index=0&id=bc4d4496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4d4496",
  null
  
)

export default component.exports